import {
  IsArray,
  IsNotEmpty,
  IsString,
  IsUUID,
  IsOptional,
} from 'class-validator';

export class DeleteParticipantsDto {
  @IsNotEmpty()
  @IsUUID()
  eventTypeId: string;

  @IsNotEmpty()
  @IsUUID()
  companyId: string;

  @IsOptional()
  @IsString()
  role?: string;

  @IsOptional()
  @IsString()
  group?: string;

  @IsNotEmpty()
  @IsArray()
  participantIds: string[];
}
